@if (dataContext && dataContext > 0) {
  <div class="numbered-circle">
    {{ dataContext }}
  </div>
}
